module.exports = require('crypto').createHmac



//////////////////
// WEBPACK FOOTER
// ./~/create-hmac/index.js
// module id = 331
// module chunks = 0 1 2 3